// extracted by mini-css-extract-plugin
module.exports = {"Header":"About_Header__2UBQy","Text":"About_Text__3JV-V","Text2":"About_Text2__26CGm","Text3":"About_Text3__FOk7h","Links":"About_Links__1IO-K","Label":"About_Label__3kdhz"};